/* Color palette definitions for kiwi skins — extracted from KiwiSkinSystem. */

export interface KiwiPalette {
  body: string;
  beak: string;
  eyeBg: string;
  pupil: string;
  accent: string;
  highlight: string;
}

export const PALETTES = {
  forest: { body: "#4a7c59", beak: "#8b6914", eyeBg: "#e8f0e4", pupil: "#1a2e1a", accent: "#6db33f", highlight: "#5d9e6e" },
  sunset: { body: "#d4724e", beak: "#c9a227", eyeBg: "#fff3e0", pupil: "#4a1a0a", accent: "#f4a460", highlight: "#e8926a" },
  neon: { body: "#00e5ff", beak: "#ff4081", eyeBg: "#0a0a2e", pupil: "#ffffff", accent: "#76ff03", highlight: "#40f0ff" },
  gold: { body: "#c9a227", beak: "#8b6914", eyeBg: "#fff8e1", pupil: "#3e2723", accent: "#ffd54f", highlight: "#d4b03a" },
  ice: { body: "#90caf9", beak: "#5c8fb8", eyeBg: "#e3f2fd", pupil: "#1a237e", accent: "#b3e5fc", highlight: "#a8d4fa" },
  retro: { body: "#8d6e63", beak: "#6d4c41", eyeBg: "#efebe9", pupil: "#3e2723", accent: "#a1887f", highlight: "#9e8078" },
  night: { body: "#5c3d99", beak: "#9c27b0", eyeBg: "#ede7f6", pupil: "#1a0033", accent: "#7e57c2", highlight: "#7351ad" },
  cherry: { body: "#e53935", beak: "#c62828", eyeBg: "#fce4ec", pupil: "#3e0000", accent: "#ef5350", highlight: "#ea5550" },
  ocean: { body: "#00838f", beak: "#006064", eyeBg: "#e0f7fa", pupil: "#002020", accent: "#26c6da", highlight: "#1a9aa3" },
  lavender: { body: "#9575cd", beak: "#7e57c2", eyeBg: "#f3e5f5", pupil: "#1a0033", accent: "#b39ddb", highlight: "#a68ad6" },
  slate: { body: "#607d8b", beak: "#455a64", eyeBg: "#eceff1", pupil: "#1a2a33", accent: "#78909c", highlight: "#708c98" },
  mint: { body: "#4db6ac", beak: "#00897b", eyeBg: "#e0f2f1", pupil: "#002420", accent: "#80cbc4", highlight: "#62c2b6" },
  ember: { body: "#ff6f00", beak: "#e65100", eyeBg: "#fff3e0", pupil: "#3e1500", accent: "#ffa726", highlight: "#ff8a1a" },
  storm: { body: "#37474f", beak: "#263238", eyeBg: "#cfd8dc", pupil: "#000a12", accent: "#546e7a", highlight: "#455d68" },
  bubblegum: { body: "#f06292", beak: "#e91e63", eyeBg: "#fce4ec", pupil: "#3e0018", accent: "#f48fb1", highlight: "#f279a4" },
  moss: { body: "#689f38", beak: "#558b2f", eyeBg: "#f1f8e9", pupil: "#1b2e0a", accent: "#9ccc65", highlight: "#7ab34c" },
} as const;
